module.exports = __webpack_public_path__ + "img/insta-6.3accd636.jpg";